import classNames from 'classnames/bind'

import styles from './Empty.module.scss'

import type {FC} from 'react'

const cx = classNames.bind(styles)

const Empty: FC = () => {
    return <div className={cx('empty')}>표시할 Trace가 없습니다.</div>
}

export default Empty
